








































import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { BButton, BCol, BFormCheckbox, BRow, BSpinner } from "bootstrap-vue";
import {
  Application,
  ApplicationsConfigModel,
} from "@/api/models/accesPlateformeBeneficiaires/accesPlateformeBeneficiaire";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component({
  components: {
    BButton,
    BCol,
    BRow,
    BSpinner,
    SearchableVueSelect,
    FeatherIcon,
    BFormCheckbox
  },
  name: "applications-config",
})
export default class ApplicationsConfig extends Vue {
  @Prop({ required: true }) applicationsAutorisees!: string[];
  @Prop({ required: true }) accesPlateformeBeneficiaireId!: string;
  @Prop({ required: true }) linkApplicationActive!: boolean;

  applicationsList: Application[] = [];
  localApplicationsAutorisees: string[] = this.applicationsAutorisees || [];
  saving: boolean = false;
  featureEnabled: boolean = JSON.parse(JSON.stringify(this.linkApplicationActive)) || false;

  async created() {
    await this.loadApplicationsList();
  }

  @Watch("applicationsAutorisees")
  onApplicationsAutoriseesChanged(val: string[]) {
    this.localApplicationsAutorisees = val;
  }

  @Watch("linkApplicationActive")
  onLinkApplicationActiveChanged(val: boolean) {
    this.featureEnabled = val;
  }

  onToggleFeature() {
    if (!this.featureEnabled) {
      this.localApplicationsAutorisees = [];
    }
    this.$emit("update:link-application-active", this.featureEnabled);
  }

  async loadApplicationsList() {
    this.$http.myressif.parametres
      .getByNom("liste_applications")
      .then((param: any) => {
        const parsed = JSON.parse(param?.valeur ?? "{}");
        this.applicationsList = Array.isArray(parsed.applications)
          ? parsed.applications
          : [];
        
      })
      .catch(() => {
        errorAlert.fire({
          title: "Erreur de chargement",
          text: "Impossible de charger la liste des applications.",
        });
      });
  }

  async saveApplicationsConfiguration() {
    this.saving = true;
    try {
      const config: ApplicationsConfigModel = {
        applicationsAutorisees: this.localApplicationsAutorisees,
        featureEnabled: this.featureEnabled
      };

      await this.$http.myressif.accesPlateformeBeneficiaire.updateApplicationsConfig(
        this.accesPlateformeBeneficiaireId,
        config
      );

      successAlert.fire({
        title: "Configuration des applications",
        text: "Configuration enregistrée avec succès.",
      });

      this.$emit("reload");
      return true;
    } catch (error: any) {
      errorAlert.fire({
        title: "Erreur d'enregistrement",
        text: error?.response?.data?.detail || error.message,
      });
      return false;
    } finally {
      this.saving = false;
    }
  }

  async syncApplicationsConfiguration() {
    this.saving = true;
    try {
      await this.saveApplicationsConfiguration();

      await this.$http.myressif.accesPlateformeBeneficiaire.syncApplicationsConfig(
        this.accesPlateformeBeneficiaireId
      );

      successAlert.fire({
        title: "Synchronisation des applications",
        text: "Synchronisation effectuée avec succès.",
      });
    } catch (error: any) {
      errorAlert.fire({
        title: "Erreur de synchronisation",
        text: error?.response?.data?.detail || error.message,
      });
    } finally {
      this.saving = false;
      this.$emit("reload");
    }
  }
}
